const fancyCranberrySnippet = () => {
  return (
    <span>
      Guy Fieri is your muse, your last Tinder date called you “a bit much” (and
      you took it as a compliment), and you’re{" "}
      <span style={{ fontStyle: "italic" }}>about</span> the buffet. Get it,
      girl.
    </span>
  )
}

const butteryGreenBeansSnippet = () => {
  return (
    <span>
      You have a weakness for fancy sweatpants, you collect vintage cookware,
      and <span style={{ fontStyle: "italic" }}>That ’70s Show</span> is your
      comfort TV. You’re not ready to admit it, but you’re gonna move to the
      suburbs. We love that for you!
    </span>
  )
}

const twiceRoastedSquashSnippet = () => {
  return (
    <span>
      You’re currently reading{" "}
      <span style={{ fontStyle: "italic" }}>
        The Art of Stress-Free Productivity
      </span>
      , you Marie-Kondo-ed your kitchen twice last year, and you love a good
      TikTok cooking hack. Live your life!
    </span>
  )
}

const spicyChorizoSnippet = () => {
  return (
    <span>
      Your dream vacation is a tour of the Mediterranean, but until then, you’re
      watching Stanley Tucci’s{" "}
      <span style={{ fontStyle: "italic" }}>Searching For Italy</span> and
      correcting your mom’s pronunciation of “Mykonos.” You’ve recently gotten
      very into vermouth.
    </span>
  )
}

const theVisionarySnippet = () => {
  return (
    <span>
      You have a fermentation station in your laundry room, you only drink natty
      wine, and you simply will not follow a recipe as written. It’s called{" "}
      <span style={{ fontStyle: "italic" }}>good taste</span>, okay?
    </span>
  )
}

export const results = [
  {
    resultID: 1,
    result: "Cacio e Pepe Rosti",
    URL: "https://www.bonappetit.com/recipe/cacio-e-pepe-rosti",
    imgURL:
      "https://assets.bonappetit.com/photos/6169bc9135619050b769409d/master/w_2240,c_limit/Cacio-E-Pepe-Ro%CC%88sti.jpg  ",
    dek: "Russet potatoes are boiled, grated, and baked with a generous amount of Parmesan cheese and pepper to make this fancy little savory cake.",
    hed: "The Perfectionist",
    snippet:
      "You always remember which side the fork goes on, your white linen tablecloth is immaculate, and you might be wearing pearls to Thanksgiving. Is that a brag? Who, you? Never.",
  },
  {
    resultID: 2,
    result: "Why-Is-It-So-Good Gravy Recipe",
    URL: "https://www.bonappetit.com/recipe/why-is-it-so-good-gravy ",
    imgURL:
      "https://assets.bonappetit.com/photos/5d9f66d8b1d2010008f50914/master/w_2240,c_limit/1119-Perfect-Gravy.jpg ",
    dek: "The depth of umami flavor in this make-ahead gravy comes from roasted poultry bones and—surprise!—a sprinkle of MSG.",
    hed: "The Middle Child",
    snippet:
      "You lost sleep over the seating chart and made a single-serving stuffing for your ONE vegan cousin, but we see you sneaking cheeky whiskey shots in the kitchen and we're here for it.",
  },
  {
    resultID: 3,
    result: "Miso Butter Mashed Potatoes",
    URL: "https://www.bonappetit.com/recipe/garlic-miso-butter-mashed-potatoes ",
    imgURL:
      "https://assets.bonappetit.com/photos/6169ba97561c23002d3dfe15/master/w_2240,c_limit/Garlic-Miso-Butter-Mashed-Potatoes.jpg ",
    dek: "A couple of spoonfuls of white or yellow miso adds a little extra umami and saltiness to these velvety, garlic-laced spuds.",
    hed: "The Visionary",
    snippet: theVisionarySnippet(),
  },
  {
    resultID: 4,
    result: "Kale Salad with Pecan Vinaigrette",
    URL: "https://www.bonappetit.com/recipe/kale-salad-with-pecan-vinaigrette ",
    imgURL:
      "https://assets.bonappetit.com/photos/6169b6e602005ea245356dea/master/w_2240,c_limit/Kale-Salad-With-Pecan-Vinaigrette.jpg ",
    dek: "This dressing checks all the boxes: It’s nutty, salty, savory, and just sweet enough, with a hefty texture that holds its own against sturdy kale.",
    hed: "The Purist",
    snippet:
      "You’re the one on the family group chat sharing articles about the health benefits of turmeric, you haven’t missed a Turkey Trot since 2002, and you’re “flexitarian”—but definitely not in an annoying way. Right, guys?",
  },
  {
    resultID: 5,
    result: "Fancy Cranberry Sauce",
    URL: "https://www.bonappetit.com/recipe/fancy-cranberry-sauce",
    imgURL:
      "https://assets.bonappetit.com/photos/5d9f8a7569a6d40009d0b721/16:9/w_2240,c_limit/1119-Perfect-Fancy-Cranberry-Sauce.jpg ",
    dek: "A sliceable, jiggly, and deeply-fruity cranberry sauce that’s spiced with bay leaves and cardamom and—don’t stress!—just as fun as the retro canned stuff.",
    hed: "The Maximalist",
    snippet: fancyCranberrySnippet(),
  },
  {
    resultID: 6,
    result: "Bitter Greens Salad with Cranberry Dressing",
    URL: "https://www.bonappetit.com/recipe/bitter-greens-with-cranberry-dressing ",
    imgURL:
      "https://assets.bonappetit.com/photos/6169bb922f34dd3430e96dfa/master/w_2240,c_limit/Bitter-Greens-With-Cranberry-Dressing.jpeg",
    dek: "Earthy endives and frisée are topped with a chunky, tangy dressing made from canned cranberry sauce, candied pecans, and salty Manchego cheese. ",
    hed: "The Radical Optimist",
    snippet:
      "Your favorite part of dinner is saying what you’re thankful for (each other, obvi!), meal prep is your middle name, and you still think about the Tony Robbins seminar you went to that one time.",
  },
  {
    resultID: 7,
    result: "Loaded Sweet Potatoes",
    URL: "https://www.bonappetit.com/recipe/loaded-sweet-potatoes ",
    imgURL:
      "https://assets.bonappetit.com/photos/5c1a6e32f212512d0e6cec50/master/w_2240,c_limit/FGFP-Loaded-Sweet-Potato-Horizontal.jpg ",
    dek: "Roasted and fried sweet potatoes under a pile of delicious things: lentils, peanuts, grapefruit, herbs, and feta cheese.",
    hed: "The Next Leveler",
    snippet:
      "Your motto is: “Better, not faster.” You make everyone walk an extra ten blocks to get beer at the “good bodega.” And J. Kenji Lopez-Alt is your kitchen muse.",
  },
  {
    resultID: 8,
    result: "Buttery Green Beans and Mushrooms with Crispy Shallots",
    URL: "https://www.bonappetit.com/recipe/green-beans-and-mushrooms-with-crispy-shallots",
    imgURL:
      "https://assets.bonappetit.com/photos/6169b61d02005ea245356de8/master/w_2240,c_limit/Green-Beans-and-Mushrooms-With-Crispy-Shallots.jpg",
    dek: "This buttery stir-fry features all the earthy mushrooms and crispy shallots you’d expect from a classic bean casserole—but is done entirely on the stovetop.",
    hed: "The Cozy Queen",
    snippet: butteryGreenBeansSnippet(),
  },
  {
    resultID: 9,
    result: "Smashed and Loaded Crispy Potatoes",
    URL: "https://www.bonappetit.com/recipe/smashed-and-loaded-crispy-potatoes ",
    imgURL:
      "https://assets.bonappetit.com/photos/5c1bdcf72efb8f2d33e39588/master/w_2240,c_limit/Basically-Crispy-Potatoes-01.jpg ",
    dek: "Twice-cooked—once in water, and a second time in the oven—ultra-crispy potatoes smothered in sour cream and bacon bits.",
    hed: "The Enthusiast",
    snippet:
      "Fall is your favorite season, you love hygge even though you don’t know how to pronounce it, and you macrame-ed a cornucopia for your Thanksgiving table. In August.",
  },
  {
    resultID: 10,
    result: "Pull-Apart Sour Cream and Chive Rolls",
    URL: "https://www.bonappetit.com/recipe/pull-apart-sour-cream-and-chive-rolls",
    imgURL:
      "https://assets.bonappetit.com/photos/5f7f4a0ca31e1f3712275861/master/w_2240,c_limit/Sour-Cream-and-Chive-Rolls.jpg ",
    dek: "These melt-in-your-mouth dinner rolls—which use tangzhong, a white roux often used to make Japanese milk bread—are the perfect, tender and pillowy landing pad for bits of gravy-soaked turkey. ",
    hed: "The High Achiever",
    snippet:
      "You mastered sourdough a decade ago, you have “cast iron” tattooed across your knuckles, and you often wear your apron at the dinner table just so people remember who’s chef.",
  },
  {
    resultID: 11,
    result: "Twice-Roasted Squash with Vanilla, Maple, and Chile",
    URL: "https://www.bonappetit.com/recipe/twice-roasted-squash-with-vanilla-maple-and-chile",
    imgURL:
      "https://assets.bonappetit.com/photos/6167519bf4957e0dd6624f5b/master/w_2240,c_limit/Twice-Roasted-Squash-With-Vanilla,-Maple,-and-Chile.jpg",
    dek: "Tender, whole-roasted kabocha squash gets torn apart and sent back into the oven to crisp up under a fragrant, sweet-spicy glaze. ",
    hed: "The Master Strategist",
    snippet: twiceRoastedSquashSnippet(),
  },
  {
    resultID: 12,
    result: "Stuffing Biscuits",
    URL: "https://www.bonappetit.com/recipe/stuffing-biscuits ",
    imgURL:
      "https://assets.bonappetit.com/photos/6169b89302005ea245356def/master/w_2240,c_limit/Stuffing-Biscuits.jpeg",
    dek: "All the herby and aromatic flavors of a classic Thanksgiving stuffing—sage, rosemary, fennel seed, and onion-y scallion–are packed into this tender, buttery biscuit.",
    hed: "The Risk Taker",
    snippet:
      "Your “low-key plans” always turn out kinda epic, you love mixing friend groups just to see what happens, and you definitely waited in line for two hours for a Cronut in 2013. (Worth it.)",
  },
  {
    resultID: 13,
    result: "Sweet Potato Tian",
    URL: "https://www.bonappetit.com/recipe/sweet-potato-tian",
    imgURL:
      "https://assets.bonappetit.com/photos/61674da1c311c6cceb6c53ed/master/w_2240,c_limit/sweetpotatotian.jpg ",
    dek: "The classic Provençal tian—a gratin of layered and sliced vegetables served right from the vessel it’s baked in—gets a Chinese American twist with sweet potatoes, ginger, miso, dark soy sauce, and five-spice powder.",
    hed: "The Can Do-er",
    snippet:
      "You love puzzles because everything has a place, your current meditation streak is 756 days straight (but who’s counting?), and tedious tasks like julienning vegetables are oddly calming for you.",
  },
  {
    resultID: 14,
    result: "Spicy Chorizo and Calabrian Chili Stuffing",
    URL: "https://www.bonappetit.com/recipe/chorizo-and-calabrian-chile-stuffing",
    imgURL:
      "https://assets.bonappetit.com/photos/6169bb2f5aaa5cd5b26fd7d2/master/w_2240,c_limit/Chorizo-and-Calabrian-Chile-Stuffing.jpg ",
    dek: "Meaty bits of spicy-tangy, Mexican-style chorizo and a handful of fiery Calabrian chiles pep-up this Thanksgiving stuffing recipe.",
    hed: "The Europhile",
    snippet: spicyChorizoSnippet(),
  },
  {
    resultID: 15,
    result: "Crunchy Honey-Chile Glazed Potatoes",
    URL: "https://www.bonappetit.com/recipe/chile-honey-glazed-fries",
    imgURL:
      "https://assets.bonappetit.com/photos/61682f204d96929e1cd2a3fa/4:5/w_2240,c_limit/tatertots_recipe_lede.jpg",
    dek: "Freezer-aisle fries, tots, or take-out leftovers tossed in a sticky-spicy honey glaze are the perfect exemplar of that very specific and beloved texture: crispy-gone-soggy.",
    hed: "The Chillest of the Chill",
    snippet:
      "4:20 is your favorite time of day, you skipped most of high-school Calculus but aced the final anyway, and you still buy Totino’s frozen pizza rolls even though you’re an adult now. It’s good to have a little fun. ",
  },
]
